module.exports = __webpack_public_path__ + "img/headphones_white.1b980f99.svg";